// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import {
  Card,
  Form,
} from "tabler-react";
import queryString from 'query-string';

import {
  LoadingButton,
  AlertComponent
} from '../../../component';
import {
  userActions,
  alertActions
} from '../../../store/actions';

let timeoutTime;

class ResetPasswordPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      password: '', // Form fields
      cpassword: '', // Form fields
      error: '',    // Initialized to handle validation errors
      token: null,
      uid: null
  };
    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      history: this.props.history
    });
  }

  handleSubmit = async(e) => {
    e.preventDefault();
    let validationCheck = this.handleValidation();
    if(validationCheck.password === '' && validationCheck.cpassword === '')
    {
      // PARSED QUERY STRING AGAIN TO ASSURE THEY ARE SAVED IN STATE
      let params = queryString.parse(this.props.location.search)
      await this.setState({token: params.token, uid: params.uid})
      this.props.reset(this.state);
      this.setState({
        alert: { type: 'success', message: 'Form submitted waiting for API' }
      })
    }
    timeoutTime = setTimeout(() => {
      if(this.props.alert.type === 'success')
      {
        this.props.history.push('/login');
      }
      this.props.clearAlerts()
      // this.props.history.push('/login');
    }, 8000)
    timeoutTime = setTimeout(async() => {
      if(this.props.alert.type === 'danger')
      {
        await this.setState({password: '', cpassword: '' })
      }
    }, 6500)
  }

  handleValidation = (e) => {
    let values = this.state;
    // same as above, but feel free to move this into a class method now.
    let errors = {
      password: '',
      cpassword: '',
  };
    if (!values.password) {
      errors.password = "This field is required";
    }
    if (!values.cpassword) {
      errors.cpassword = "This field is required";
    }
    if (values.cpassword !== values.password) {
      errors.cpassword = "Password don't match";
    }
    this.setState({
      error: errors
    })
    return errors;
  }

  async componentDidMount()
  {
    // Save query string parameters
    let params = queryString.parse(this.props.location.search)
    await this.setState({token: params.token, uid: params.uid})
  }

  render() {
    let alertComponent;
    const { isReset,alert } = this.props;
    const errors = this.state.error;
    if (alert !== {}) {
      alertComponent =  (alert.message&&alert.type) && <AlertComponent alert={alert} auth={true}/>;
    }
    return (
      <Form className="card" onSubmit={this.handleSubmit}>
        <Card.Body className="p-4">
          <div className="text-center mb-2">
            <img src="./demo/logo.png" className="h-6 " alt="logo"/>
          </div>
          <Card.Title className="text-center pt-6">Reset Password</Card.Title>
          {alertComponent ? alertComponent  : ''}
            <Form.Group>
                <Form.Label>New Password</Form.Label>
                <Form.Input
                  type="password"
                  name="password"
                  placeholder= 'Password'
                  error= {errors && errors.password}
                  onChange={this.handleChange}
                  value={this.state.password}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>Confirm Password</Form.Label>
                <Form.Input
                  type="password"
                  name="cpassword"
                  placeholder= 'Confirm Password'
                  error= {errors && errors.cpassword}
                  onChange={this.handleChange}
                  value={this.state.cpassword}
                />
            </Form.Group>
        </Card.Body>
        <Card.Footer className="text-right">
          <LoadingButton className="btn btn-block btn-primary" loadingState={isReset} preloadingText="Change Password" loadingText="Change Password"/>
        </Card.Footer>
      </Form>
    );
  }

  componentWillUnmount(){
    clearTimeout(timeoutTime);
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { isReset } = state.user;
  return {
    alert,
    isReset
  };
}

const mapDispatchToProps = {
  reset: userActions.reset_password,
  errorAlerts: alertActions.error,
  successAlerts: alertActions.success,
  clearAlerts: alertActions.clear
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPasswordPage));